import moment from "moment-timezone";

export const formatDateTimeString = (dt: string) =>
  moment(dt).tz("America/Los_Angeles").format("MM/DD/YY h:mm a z");

export const formatDateString = (dt: string) =>
  moment(dt).tz("America/Los_Angeles").format("MM/DD/YY");

export const formatDateStringMMDDYYYY = (dt: string) =>
  moment(dt).tz("America/Los_Angeles").format("MM/DD/YYYY");
